import {
    Box,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow
} from "@mui/material";
import {translate} from "../../translate/translate";
import * as React from "react";
const TableOnlyBodyComponent = (props: any) => {
    const {
        displayedColumns,
        handleRowSelect,
        selectedRows,
        renderCellHandler,
        cellCustomStyleHandler,
        rowCustomStyleHandler,
        stickyHeader,
        disablePointer,
        collapse=false,
        CollapseComponent,
        removeStripe=false,
    } = props;

    const renderCell = (column: string, index: number, row: any) => {
        return column === "isRowSelectable" ? (
            <Checkbox
                checked={selectedRows.some((selectedRow: any) => selectedRow.id === row.id)}
                onChange={() => handleRowSelect(row)}
            />
        ) : {}
    };

    return (
        <Box sx={{width: "100%"}}>
            <Paper>
                <TableContainer>
                    <Table stickyHeader={stickyHeader} size="small" sx={{ tableLayout: "fixed" }}>
                        <TableBody sx={{cursor: disablePointer ? "default" : "pointer"}}>
                            {props.state && props.state.length > 0 ? (
                                props.state.map((row: any, index: any) => (
                                    <React.Fragment key={`fragment-${row.id}-${index}`}>
                                        <TableRow
                                            key={`row-${row.id}-${index}`}
                                            className={removeStripe ? "no-stripe" : ""}
                                            sx={{
                                                "&:last-child td, &:last-child th": {
                                                    border: 0,
                                                },
                                                ...rowCustomStyleHandler ? rowCustomStyleHandler(row) : {},
                                            }}
                                        >
                                            {displayedColumns
                                                .filter((obj: string) => obj !== "action")
                                                .map((column: string, index: any) => (
                                                    <TableCell
                                                        key={`cell-${row.id}-${index}`}
                                                        sx={{
                                                            wordBreak: "break-word",
                                                            fontSize: "14px",
                                                            lineHeight: "20px",
                                                            justifyContent: "center",
                                                            ...cellCustomStyleHandler ? cellCustomStyleHandler(column, row) : {},
                                                        }}
                                                    >
                                                        {index === 0 && collapse && CollapseComponent ? (
                                                            row?.children_components && row?.children_components.length > 0 ? (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        float: "left",
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        props.handleSingleClick(row.id);
                                                                    }}
                                                                >
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display: "block",
                                                                        float: "left",
                                                                        width: "20px",
                                                                        height: "20px",
                                                                    }}
                                                                />
                                                            )
                                                        ) : null}

                                                        {renderCellHandler && renderCellHandler[column] ? renderCellHandler[column](column, index, row) : renderCell(column, index, row)}
                                                    </TableCell>
                                                ))}
                                        </TableRow>
                                    </React.Fragment>
                                ))
                            ) : (
                                <TableRow key="empty-row">
                                    <TableCell
                                        key="empty-cell"
                                        colSpan={displayedColumns.length}
                                        sx={{
                                            textAlign: "center",
                                            fontSize: "14px",
                                            padding: "8px",
                                        }}
                                    >
                                        {translate.t("empty_listing")}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default TableOnlyBodyComponent;
